import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TableSortService {

  constructor() { }

  // Sorts the array based on the specified column and order
  sortRows(array: any[], column: string, order: string): any[] {
    return array.slice().sort((a, b) => {
      if (order === 'asc') {
        return this.compare(a[column], b[column]);
      } else {
        return this.compare(b[column], a[column]);
      }
    });
  }

  // Toggles the sort order
  toggleSortOrder(currentOrder: string): string {
    switch (currentOrder) {
      // case 'original':
      //   return 'asc';
      case 'asc':
        return 'desc';
      case 'desc':
        return 'asc';
      default:
        return 'asc';
    }
  }

  // Compares two values based on their data types
  private compare(a: any, b: any): number {
    if (typeof a === 'number' && typeof b === 'number') {
      return a - b;
    } else if (typeof a === 'string' && typeof b === 'string') {
      return a.localeCompare(b);
    } else if (a instanceof Date && b instanceof Date) {
      return a.getTime() - b.getTime();
    } else if (typeof a === 'boolean' && typeof b === 'boolean') {
      return a === b ? 0 : a ? 1 : -1;
    } else {
      // Fallback for unsupported data types (treat them as strings)
      return String(a).localeCompare(String(b));
    }
  }
}
